export const portaleGrupy = {
  groups: [
    {
      id: "1",
      continent: "Europa",
      desc:
        "zwiedzaj Stary Kontynent, latem wybieraj śródziemnomorskie kurorty, a zimą wypoczywaj w Alpach",
      links: [
        "albania.info.pl",
        "austria.pl",
        "belgia.info.pl",
        "bosnia.pl",
        "bulgaria.pl",
        "chorwacja.pl",
        "cypr.net.pl",
        "czarnogora.pl",
        "czechy.pl",
        "dania.info.pl",
        "estonia.info.pl",
        "finlandia.info.pl",
        "francja.pl",
        "grecja.com.pl",
        "hiszpania.com.pl",
        "holandia.info.pl",
        "irlandia.info.pl",
        "islandia.info.pl",
        "litwa.info.pl",
        "lotwa.info.pl",
        "macedonia.net.pl",
        "majorka.com.pl",
        "malta-gozo.pl",
        "niemcy.com.pl",
        "norwegia.info.pl",
        "portugalia.com.pl",
        "rosja.pl",
        "rumunia.info.pl",
        "serbia.pl",
        "slowacja.com.pl",
        "slowenia.info.pl",
        "szwajcaria.com.pl",
        "szwecja.info.pl",
        "turcja.com.pl",
        "wegry.biz.pl",
        "wielkabrytania.com.pl",
        "wlochy.pl",
        "wyspykanaryjskie.pl"
      ]
    },
    {
      id: "2",
      continent: "Afryka",
      desc:
        "odkryj tajemnice starożytnych cywilizacji, odpoczywaj na bezkresnych plażach lub wybierz się na safari",
      links: [
        "egipt.info.pl",
        "gambia.com.pl",
        "kenia.info.pl",
        "maroko.com.pl",
        "mauritius.pl",
        "namibia.pl",
        "rpa.pl",
        "seszele.com.pl",
        "tanzania.pl",
        "tunezja.com.pl",
        "wyspyzielonegoprzyladka.pl"
      ]
    },
    {
      id: "3",
      continent: "Azja",
      desc:
        "zachwyć się rozmaitością krajobrazu, poznaj fascynujące kultury, zanurz się w luksusie i korzystaj z mądrości wschodu",
      links: [
        "bali.pl",
        "chiny.com.pl",
        "emiratyarabskie.pl",
        "indie.com.pl",
        "izrael.pl",
        "jordania.info.pl",
        "malediwy.com.pl",
        "malezja.info.pl",
        "srilanka.com.pl",
        "tajlandia.com.pl"
      ]
    },
    {
      id: "4",
      continent: "Ameryka Płn. i Płd.",
      desc: "podążaj śladami Kolumba i odkrywaj kraje pełne kontrastów",
      links: [
        "argentyna.info.pl",
        "belize.com.pl",
        "brazylia.com.pl",
        "chile.info.pl",
        "hawaje.com.pl",
        "kanada.pl",
        "karaiby.pl",
        "kolumbia.net.pl",
        "meksyk.com.pl",
        "peru.info.pl",
        "stanyzjednoczone.pl",
        "wenezuela.info.pl"
      ]
    },
    {
      id: "5",
      continent: "Australia i Oceania",
      desc:
        "wybierz się w podróż na kraniec świata, odwiedź kraj kangura lub znajdź własną rajską wyspę",
      links: ["polinezja.pl"]
    }
  ]
};
